/**
 * Swatches
 *
 * @module swatches
 */
 const component = {

    /**
     * Init component
     * 
     * @returns {undefined}
     */
	init: () => {

        component.initOptions({
            imageSize: '70',
            imageExtension: 'png',
            divisor: '/'
        });

        /**
         * Swatches module api
         * 
         * @global
         */
    	window.theme.swatches = component;
	},

    /**
     * Init component options.
     * 
     * @param {object} options Object options.
     * @returns {object} Object options.
     */
    initOptions: options => {
        
        component.options = options;

        if (typeof window.theme.swatches != 'undefined' && typeof window.theme.swatches.options != 'undefined') {
            component.options = {...component.options, ...window.theme.swatches.options}
        }

        return component.options;
    },

    /**
     * Get product swatches.
     * 
     * @param {object} product Product data.
     * @param {string} optionName Product option name.
     * @returns {Array} Product swatches array.
     */
    getSwatches: (product, optionName) => {

        let swatches = [], option = component.getProductOptionByName(product, optionName);

        if (option) {

            let productSwatches = component.getSwatchImagesFromProduct(product);

            option.values.forEach(value => {

                let item = { "value": value};

                let variant = component.getVariantByOptionValue(product, option, value);

                if (variant) {

                    item.image_id = variant.image_id;

                    let image = component.getVariantImage(product, variant);
                    
                    if (image && image.alt) {

                        // Format alt and convert char code 160 to 32
                        let alt = image.alt.toLowerCase().trim().replace(/\s+/g, " ");
                        
                        if (productSwatches[alt]) {

                            let src = image.src,
                                ext = window.theme.file.getExtension(src);

                            item.src = src.replace(new RegExp(ext + '$'), '_' + component.options.imageSize + 'x' + ext);

                        } else {

                            item.src = component.getSwatchSrcFromFiles(option.name, value);
                        }

                    } else {

                        item.src = component.getSwatchSrcFromFiles(option.name, value);
                    }
                }

                swatches.push(item);
            });
        }

        return swatches;
    },

    /**
     * Get variant image.
     * 
     * @param {object} product Product data.
     * @param {object} variant Product variant data.
     * @returns {object} Variant image object.
     */
    getVariantImage: (product, variant) => {

        if (product.images) {
            return product.images.find(item => {return item.id == variant.image_id});
        }

    },

    /**
     * Get product variant by option and value.
     * 
     * @param {object} product Product data.
     * @param {object} option Product option data.
     * @param {string} value Option value.
     * @returns {Array} Array with varaint data.
     */
    getVariantByOptionValue: (product, option, value) => {

        return product.variants.find(item => {return item['option'+option.position] == value});
    },

    /**
     * Get product option by option name.
     * 
     * @param {object} product Product data.
     * @param {string} optionName Option name.
     * @returns {Array} Array with a product option with its values.
     */
    getProductOptionByName: (product, optionName) => {

        return product.options.find(item => {return item.name.toUpperCase() == optionName.toUpperCase()});
    },

    /**
     * Get swatch images from product level.
     * 
     * @param {object} product Product data.
     * @returns {Array} Array with swatch images from a product.
     */
    getSwatchImagesFromProduct: product => {

        let swatches = [];

        if(product.images) {
            product.images.forEach(image => {

                if (image.alt) {
    
                    let alt = image.alt.toLowerCase();
    
                    if (alt.includes('swatch')) {
    
                        let key = '';
    
                        alt.split(component.options.divisor).forEach( (label, index) => {
    
                            if (index < 2) {
    
                                label = label.trim();
    
                                if (index == 0) {
    
                                    key = label;
    
                                } else {
    
                                    key = key + ' ' + component.options.divisor + ' ' + label;
                                }
                            }
                        });
                        
                        swatches[ key ] = image;
                    }
                }
            });
        }

        return swatches;
    },

    /**
     * Get a custom image swatch src from Shopify files.
     * 
     * @param {string} name Variant option title.
     * @param {string} value Variant option value.
     * @returns {string} Swatch image url from Shopify Files.
     */
     getSwatchSrcFromFiles: (name, value) => {

        value = component.formatString(value);
        name = component.formatString(name);

        if(value == 'medium') {
            value = value + '_default';
        }

        if (typeof window.theme.file_url != 'undefined') {

            return window.theme.file_url.replace('files/?', 'files/swatch_-_' + name + '_-_' + value + '_' + component.options.imageSize + 'x.' + component.options.imageExtension + '?');

        } else {

            return '';
        }
    },

    /**
     * Format string.
     * 
     * @param {string} string Simple string.
     * @returns {string} Formated string.
     */
    formatString: string => {

        return string.replace(/ /g, '_').toLowerCase();
    }
};

export default component;
